module.exports = __webpack_public_path__ + "img/NoMarketingCookie.e4fe9cfd.png";